export const requiredRule =
  (message = "Это поле обязательно") =>
  (value) =>
    String(value ?? "").trim() ? "" : message;

export const checkedRule =
  (message = "Это поле обязательно") =>
  (value) =>
    value === true ? "" : message;

export const phoneRule =
  (message = "Введите телефон полностью") =>
  (value) =>
    String(value ?? "").replace(/\D+/g, "").length === 11 ? "" : message;

export const emailRule =
  (message = "Некорректный email") =>
  (value) =>
    !value || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) ? "" : message;

export default {
  props: {
    showErrorsInput: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      errors: {},
    };
  },
  methods: {
    getFieldValue(field) {
      if (this.form && field in this.form) {
        return this.form[field];
      }
      return this[field];
    },

    getFieldError(field, rules) {
      const value = this.getFieldValue(field);

      for (const rule of rules) {
        const message = rule(value);
        if (message) {
          return message;
        }
      }

      return "";
    },

    validateForm() {
      const errors = {};
      let isValid = true;

      for (const field in this.validationRules) {
        const message = this.getFieldError(field, this.validationRules[field]);

        if (message) {
          errors[field] = message;
          isValid = false;
        }
      }

      this.errors = errors;
      return isValid;
    },

    clearError(field) {
      if (!this.errors[field]) return;
      this.errors = { ...this.errors, [field]: "" };
    },
  },
};